import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';

import {
  updateMusicLinkSource,
} from 'redux/music-links/actions';

import MusicField from 'components/dashboard/music-links-content/MusicField';

import './MusicLinkSource.css';

const MusicLinkSource = ({
  musicLinkId,
  musicLinkName,
  updateMusicLinkSourceSuccess,
  updateMusicLinkSourceError,
  updateMusicLinkSource,
}) => {
  const { t } = useTranslation();
  const [ currentValue, setCurrentValue ] = useState(musicLinkName || null);
  const [ errorId, setErrorId ] = useState(null);

  useEffect(() => {
    if (currentValue !== musicLinkName) {
      setCurrentValue(musicLinkName);
    }
  }, [ updateMusicLinkSourceSuccess ]);

  const handleInputSubmit = (id, value) => {
    setCurrentValue(value);
    setErrorId(id);
    if (value !== '') {
      updateMusicLinkSource(id, { link_source: value });
    }
  };

  const handleSourceError = () => {
    if (currentValue === '') {
      return {
        id: `music_link_source_id_${musicLinkId}`, text: 'Source cannot be empty'
      };
    }
    if (updateMusicLinkSourceError && errorId === musicLinkId) {
      return {
        id: `music_link_source_id_${errorId}`,
        text: updateMusicLinkSourceError.error,
      };
    }
    return null;
  };

  return (
    <div className="music-link-source__component">
      <MusicField
        className="music-link-source-input"
        id={musicLinkId}
        value={currentValue}
        handleSubmit={handleInputSubmit}
        error={handleSourceError()}
      />
      <div className="subtext">{t("Scan Source")}</div>
    </div>
  );
};

MusicLinkSource.propTypes = {
  musicLinkId: PropTypes.number,
  musicLinkName: PropTypes.string,
  updateMusicLinkSource: PropTypes.func,
  updateMusicLinkSourceSuccess: PropTypes.object,
  updateMusicLinkSourceError: PropTypes.object,
};
MusicLinkSource.defaultProps = {
  musicLinkId: null,
  musicLinkName: null,
  updateMusicLinkSource: null,
  updateMusicLinkSourceSuccess: null,
  updateMusicLinkSourceError: null,
};

const mapStateToProps = state => (
  {
    updateMusicLinkSourceSuccess: state.musicLinksReducer.updateMusicLinkSourceSuccess,
    updateMusicLinkSourceError: state.musicLinksReducer.updateMusicLinkSourceError,
  }
);

export default connect(
  mapStateToProps,
  {
    updateMusicLinkSource,
  },
)(MusicLinkSource);
